import { Box, IconButton, Link, Tooltip, Typography } from '@mui/material';
import { Trash2 } from 'lucide-react';
import { ReactNode } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

interface PropertiesPanelProps {
    children: ReactNode;
    titleId?: string;
    subtitle?: ReactNode;
    showTitle?: boolean;
    onViewDicom?: () => void;
    onDelete?: () => void;
}

export default function PropertiesPanel({
    children,
    titleId = 'properties',
    subtitle,
    showTitle = true,
    onViewDicom,
    onDelete,
}: PropertiesPanelProps) {
    const intl = useIntl();

    return (
        <Box>
            {showTitle && (
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={1}
                >
                    <Box display="flex" gap={1} alignItems="center">
                        <Typography fontSize={12} fontWeight={500}>
                            <FormattedMessage id={titleId} />
                        </Typography>
                    </Box>
                    <Box display="flex" gap={1} alignItems="center">
                        {onViewDicom && (
                            <Box display="flex" alignItems="center">
                                <Link
                                    component="button"
                                    underline="hover"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        onViewDicom();
                                    }}
                                    sx={{ fontSize: 11, cursor: 'pointer' }}
                                >
                                    <FormattedMessage id="dicom.tagViewer.showLink" />
                                </Link>
                            </Box>
                        )}
                        {onDelete && (
                            <Tooltip
                                title={intl.formatMessage({
                                    id: 'delete',
                                })}
                            >
                                <IconButton
                                    size="small"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        onDelete();
                                    }}
                                    sx={{
                                        p: 0.25,
                                    }}
                                    aria-label={intl.formatMessage({
                                        id: 'delete',
                                    })}
                                >
                                    <Trash2 size={14} />
                                </IconButton>
                            </Tooltip>
                        )}
                    </Box>
                </Box>
            )}
            {subtitle}
            <Box
                display="grid"
                gridTemplateColumns="auto 1fr"
                gap="3px 6px"
                alignItems="baseline"
                sx={{
                    '& .MuiTypography-root': {
                        fontSize: 11,
                        lineHeight: 1.2,
                    },
                }}
            >
                {children}
            </Box>
        </Box>
    );
}
